import { render, staticRenderFns } from "./purchaseDetail.vue?vue&type=template&id=6273362e&scoped=true"
import script from "./purchaseDetail.vue?vue&type=script&lang=js"
export * from "./purchaseDetail.vue?vue&type=script&lang=js"
import style0 from "./purchaseDetail.vue?vue&type=style&index=0&id=6273362e&prod&lang=scss&scoped=true"
import style1 from "./purchaseDetail.vue?vue&type=style&index=1&id=6273362e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6273362e",
  null
  
)

export default component.exports